
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/posts",
      function () {
        return require("private-next-pages/dashboard/posts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/posts"])
      });
    }
  